import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const FinancialReports = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Finansal Raporlar
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Finansal raporlar burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default FinancialReports;
